import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Bell, Save } from 'lucide-react';
import LoaderOverlay from '../common/LoaderOverlay';

export interface NotificationItem {
  key: string;
  label: string;
  description: string;
  enabled: boolean;
}

interface NotificationTypesProps {
  items: NotificationItem[];
  onToggle: (key: string) => void;
  onSave: () => void;
  isSaving: boolean;
  description?: string;
}

const NotificationTypes = ({
  items,
  onToggle,
  onSave,
  isSaving,
  description,
}: NotificationTypesProps) => {
  return (
    <LoaderOverlay isLoading={isSaving} loadingText="Saving...">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2 text-base sm:text-lg">
            <Bell className="h-5 w-5 flex-shrink-0" />
            <span>Notification Types</span>
          </CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-4">
            {items.map(item => (
              <div key={item.key} className="flex items-center justify-between">
                <div className="space-y-0.5 min-w-0 flex-1 mr-2">
                  <Label className="text-sm">{item.label}</Label>
                  <p className="text-xs sm:text-sm text-muted-foreground">
                    {item.description}
                  </p>
                </div>
                <Button
                  variant={item.enabled ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => onToggle(item.key)}
                >
                  {item.enabled ? 'Enabled' : 'Disabled'}
                </Button>
              </div>
            ))}
          </div>
          <div className="flex justify-center sm:justify-end pt-4">
            <Button onClick={onSave} disabled={isSaving}>
              <div className="flex items-center space-x-2">
                <Save className="h-4 w-4" />
                <span>Save Changes</span>
              </div>
            </Button>
          </div>
        </CardContent>
      </Card>
    </LoaderOverlay>
  );
};
export default NotificationTypes;
